import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/legalentity-general-types/legalentity/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchLegalEntityTenants =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useSuspenseQuery
